import { gql } from "@apollo/client";

export const UPDATE_ADMIN_NOTIFICATION_TOGGLE = gql`
  mutation updateAdminNotificationToggle(
    $saId: UUID!
    $saNotificationEnabled: Boolean!
    $saNotificationChangedTime: Datetime!
  ) {
    updateSchoolAdminBySaId(
      input: {
        schoolAdminPatch: {
          saNotificationEnabled: $saNotificationEnabled
          saNotificationChangedTime: $saNotificationChangedTime
        }
        saId: $saId
      }
    ) {
      clientMutationId
    }
  }
`;
